const _ = require('lodash');
const { loadZendeskChat } = require("./utils");

function boot(profile, options = {}) {
    const enabled = _.get(profile, 'chat_enabled', false);
    const isLoggedIn = _.get(profile, 'isLoggedIn', false);
    if (enabled && isLoggedIn) {
        loadZendeskChat(profile, options)
    }
}

module.exports = {
    boot,
};
